import {
    Box,
    Breadcrumbs,
    Button,
    Container,
    Divider,
    Input,
    InputAdornment,
    InputBase,
    MenuItem,
    OutlinedInput,
    Pagination,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { TextFieldsOutlined } from "@mui/icons-material";

function UserDashboard() {
    // fetch api

    // store

    return (
        <>
            {/** Breadcrumbs */}
            <Container sx={{ marginY: 2 }}>
                <Breadcrumbs sx={{ my: 1 }}>
                    <div>Admin</div>
                    <div>Users</div>
                </Breadcrumbs>
                <Divider />
            </Container>

            {/** Header */}
            <Container sx={{ marginY: 3 }}>
                <Box sx={{ display: "flex" }}>
                    <Box sx={{ flexGrow: 1 }}>
                        <Typography variant="h1" fontSize={34} fontWeight="bold">
                            Users
                        </Typography>
                    </Box>
                    <Box>
                        <Button variant="contained">New User</Button>
                    </Box>
                </Box>
            </Container>

            {/** Filder */}
            <Container sx={{ marginY: 3 }}>
                <Tabs value="active">
                    <Tab value="active" label="Active (-)" />
                    <Tab value="admin" label="Admin (-)" />
                    <Tab value="system-bot" label="System Bot (-)" />
                    <Tab value="deactived" label="Deactived (-)" />
                </Tabs>

                <Divider />

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        flexWrap: "wrap",
                        gap: 1,
                        margin: 2,
                        marginBottom: 4,
                    }}
                >
                    <OutlinedInput
                        type="text"
                        variant="outlined"
                        size="small"
                        placeholder="Search by name, username"
                        startAdornment={
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        }
                        sx={{ flexGrow: 1 }}
                    />
                    <strong>Sort by</strong>
                    <Select variant="outlined" size="small" value="name">
                        <MenuItem value="name">Name</MenuItem>
                        <MenuItem value="createdAt desc">Last created</MenuItem>
                        <MenuItem value="createdAt asc">Oldest crated</MenuItem>
                    </Select>
                </Box>
            </Container>

            {/** Content */}
            <Container sx={{ marginY: 3 }}>
                {/** Table */}
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>?</TableCell>
                                <TableCell>?</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>No Data</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                {/** Pagination */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: 3,
                    }}
                >
                    <Pagination count={999} />
                </Box>
            </Container>
        </>
    );
}

export default UserDashboard;
